module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-04.12f55b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-04.jpg
// module id = vO+H
// module chunks = 1